module.exports = __webpack_public_path__ + "img/KinokoTable67.dc6b12c0.jpg";